// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.v-data-table[data-v-686f30b3] th,\n.v-data-table[data-v-686f30b3] .v-data-table-footer {\n  font-size: 12px !important;\n}\n.v-data-table[data-v-686f30b3] td {\n  font-size: 14px !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
